import React from 'react'
import { graphql } from 'gatsby'
import { mapEdgesToNodes } from '../libs/helpers'
import GraphQLErrorList from '../components/graphql-error-list'

import SEO from '../components/seo'
import Layout from '../containers/layout'
import BlogSection from 'Section/Blog'

export const query = graphql`
  query BlogPageQuery($lang: String) {
    posts: allSanityPost(
      limit: 100
      sort: { fields: [publishedAt], order: DESC }
      filter: { postLanguage: { eq: $lang } }
    ) {
      edges {
        node {
          id
          publishedAt
          category {
            title
          }
          mainImage {
            asset {
              url
              _id
            }
          }
          title
          _rawExcerpt
          slug {
            current
          }
        }
      }
    }
  }
`

const BlogPage = (props) => {
  const { data, errors } = props

  if (errors) {
    return (
      <Layout>
        <GraphQLErrorList errors={errors} />
      </Layout>
    )
  }

  const blogNodes = data && data.posts && mapEdgesToNodes(data.posts)

  return (
    <Layout shouldHaveSpaceForNav disableFooterOverlay>
      <SEO title="News" slug={'/news'} />
      {blogNodes && blogNodes.length > 0 && (
        <BlogSection blogNodes={blogNodes} />
      )}
    </Layout>
  )
}

export default BlogPage
